import { Component } from '@angular/core';
import { AuthService } from '@app-core/services/auth/auth.service';
import * as LogRocket from 'logrocket';
import { environment } from '@environments/environment';
import { FirestoreService } from '@app-services/deployments/firestore.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SoftwareUpdate } from '@app-core/classes/software-update';
//import { get } from 'lodash';

// Logrocket
LogRocket.init(environment.logRocket);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends SoftwareUpdate {
  title = 'leanstaffing-quality-frontend';

  constructor(
    private authService: AuthService,
    firestoreService: FirestoreService,
    router: Router,
    dialog: MatDialog
  ) {
    super(firestoreService, router, dialog);
  }


  override ngOnInit(): void {
    super.ngOnInit();
    this.getUser();
  }

  public getUser() {
    const data = this.authService.getTokenCokie();
    const userData = {
      id: data.user.id,
      name: data.user.name,
      email: data.user.email,
      avatar: data.user.avatar,
      code: data.user.code,
      template: data.user.template,
      position: data.user.position,
      customerProfile: data.user.customerProfile,
      profile: data.user.profile,
    };
    //const permissions = get(data, 'user.Permissions', '');
    localStorage.setItem('token', data.token);
    localStorage.setItem('permissions', JSON.stringify(data.user.Permissions));
    localStorage.setItem('userData', JSON.stringify(userData));
    this.setCustomer(data.customer, userData.avatar);
    // Logrocket
    LogRocket.init(environment.logRocket);
    LogRocket.identify(userData.id, {
      name: userData.name,
    });
    /*if (environment.production) {
      (window as any).pendo.initialize({
        visitor: {
          id: userData.email,
          full_name: userData.name,
          role: permissions[0],
        },
      });
    }*/
  }

  setCustomer(data, avatar) {
    const customerData = {
      id: data?.id,
      name: data?.name,
      avatar,
      theme: data?.theme,
      logo: data?.logo,
    };
    localStorage.setItem('customer', JSON.stringify(customerData));
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
